import METADATA from "./TranslationValueEntity.metadata.js";
import { BaseEntity } from "clavis-nxt-components-custdevtm";

class TranslationValueEntity extends BaseEntity {
  constructor(id, en, hu) {
    super();
    this.id = id;
    this.en = en;
    this.hu = hu;
  }
}

METADATA.connect(TranslationValueEntity);

export { TranslationValueEntity };
